module.exports = __webpack_public_path__ + "img/terms_600.f8e25c01.png";